export enum AddBidErrorsEnum {
    LOW_BID = "Your bid value should be equal or greater than the Max bid",
    NO_BID = "Please provide a valid Bid value",
    LOW_BALANCE = "Insufficient balance",
}
